import axios from 'axios'

import { getAuthSession } from '@/services/auth'
import { normalizeApiError } from '@/services/api/errors'

export const apiClient = axios.create({
  /** Local Laravel default; set `VITE_API_BASE_URL` in `.env` for production. */
  baseURL: import.meta.env.VITE_API_BASE_URL || 'http://127.0.0.1:8000',
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
})

apiClient.interceptors.request.use((config) => {
  const token = getAuthSession()

  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }

  // Default Content-Type is application/json; FormData must use multipart with a boundary.
  if (config.data instanceof FormData) {
    delete config.headers['Content-Type']
  }

  return config
})

apiClient.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(normalizeApiError(error)),
)
